import { render, staticRenderFns } from "./menu-tab-bar.vue?vue&type=template&id=43ff5e90&scoped=true"
import script from "./menu-tab-bar.vue?vue&type=script&lang=js"
export * from "./menu-tab-bar.vue?vue&type=script&lang=js"
import style0 from "./menu-tab-bar.vue?vue&type=style&index=0&id=43ff5e90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff5e90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ff5e90')) {
      api.createRecord('43ff5e90', component.options)
    } else {
      api.reload('43ff5e90', component.options)
    }
    module.hot.accept("./menu-tab-bar.vue?vue&type=template&id=43ff5e90&scoped=true", function () {
      api.rerender('43ff5e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/menu-tab-bar.vue"
export default component.exports